export default __webpack_public_path__ + "static/media/Vaping.d8d64fb7.png";